import { formatDate } from '../../../utils/date';
import CalendarService from '../services/CalendarService';

export const getCalendarEvents = async (idRessource) => {
	if (idRessource) {
		const { data, status } = await CalendarService.getCalendarEvents(
			idRessource,
		);
		if (status === 200) {
			return data;
		}
	}
	return false;
};

export const getSkills = async () => {
	const { data, status } = await CalendarService.getSkills();
	if (status === 200) {
		return data;
	}
	return false;
};

export const getSectors = async () => {
	const { status, data } = await CalendarService.getSectors();
	if (status === 200) {
		return data;
	}
	return false;
};

export const getResources = async (params) => {
	const { status, data } = await CalendarService.getResources(params);
	if (status === 200) {
		return data;
	}
	return false;
};

export const deleteUnaivability = async (id) => {
	const data = await CalendarService.deleteUnaivability(id);
	if (data.status.toString() === '204') {
		return data.status;
	}
	return false;
};

export const addUnaivability = async (start, end, idRessource) => {
	const data = await CalendarService.addUnaivability(start, end, idRessource);
	if (data.status.toString() === '201') {
		return data.data;
	}
	return false;
};

export const filterResources = (selectedSkills, resources) => {
	if (selectedSkills) {
		// filter resources by selected skills
		const newResources = resources.filter((resource) => {
			const find = resource.skills.find((skill) => {
				const findSkill = selectedSkills.find(
					(selectedSkill) => selectedSkill.id === skill.id,
				);
				return findSkill;
			});
			return find;
		});

		return newResources;
	}
	return [];
};

export const filterSkills = (availableSkills, skills) => {
	if (availableSkills) {
		// filter skills by resource available skills
		const newSkills = skills.filter((skill) => {
			const find = availableSkills.find(
				(resourceSkill) => resourceSkill.id === skill.id,
			);
			return find;
		});

		return newSkills;
	}
	return [];
};

export const filterSectors = (availableSectors, sectors) => {
	if (availableSectors) {
		// filter sectors by resource available sectors
		const newSectors = sectors.filter((sector) => {
			const find = availableSectors.find(
				(resourceSector) => resourceSector.code === sector.code,
			);
			return find;
		});

		return newSectors;
	}
	return [];
};

export const filterBySkillsAndSectors = (filters) => {
	const filteredResources = filters.resources.filter((resource) => {
		let resourceSelected = false;

		const selectedSkills = filters.skills.filter((skill) => skill.selected);

		const selectedSectors = filters.sectors.filter(
			(sector) => sector.selected,
		);
		let nbSkills = 0;

		if (selectedSkills.length > 0) {
			resource.skills.forEach((skill) => {
				selectedSkills.forEach((selectedSkill) => {
					if (skill.id === selectedSkill.id) {
						resourceSelected = true;
						nbSkills += 1;
					}
				});
			});
			if (selectedSkills.length !== nbSkills) {
				return false;
			}
		} else {
			resourceSelected = true;
		}

		let nbSectors = 0;
		if (selectedSectors.length > 0 && resourceSelected) {
			resourceSelected = false;
			resource.sectors.forEach((sector) => {
				selectedSectors.forEach((selectedSector) => {
					if (sector.code === selectedSector.code) {
						resourceSelected = true;
						nbSectors += 1;
					}
				});
			});
			if (selectedSectors.length !== nbSectors) {
				return false;
			}
		}

		if (selectedSkills.length === 0 && selectedSectors.length === 0) {
			resourceSelected = true;
		}

		return resourceSelected;
	});

	return filteredResources;
};

export const getFormatedEvents = (planning, theme) => {
	const events = [];
	if (planning.codeError) {
		return events.push({ codeError: planning.codeError });
	}

	planning.forEach((item) => {
		const date = new Date(item.date);
		const formatedDate = formatDate(date);
		events.push({
			id: item.id,
			start: item.availabilityStartAt,
			end: item.availabilityEndAt,
			display: 'background',
			color: theme.colors.background,
			className: 'ouvert',
		});

		if (item.unavailabilities) {
			item.unavailabilities.forEach((timeslot) => {
				events.push({
					id: timeslot.id,
					start: timeslot.start,
					end: timeslot.end,
					display: 'foreground',
					color: theme.colors.unavailabilityColor,
					interactive: true,
					extendedProps: {
						unavailability: timeslot,
					},
					title: 'Indisponible',
					className: 'indispo',
				});
			});
		}
		const nbDate = [];
		item.activities.forEach((event) => {
			const classNames = ['activity'];
			if (event.comment !== undefined && event.comment?.trim() !== '') {
				classNames.push('activityWithcomment');
			}

			events.push({
				id: item.id,
				title: event.title,
				start: event.startAt,
				end: event.endAt,
				interactive: true,
				color: theme.colors.activityColor,
				extendedProps: {
					activity: event,
				},
				className: classNames.join(' '),
			});
		});
	});

	return events;
};

export const editPlanning = async (start, end, idRessource, weekType) => {
	const data = await CalendarService.editPlanning(
		start,
		end,
		idRessource,
		weekType,
	);
	if (data.status.toString() === '201') {
		return data.data;
	}
	return false;
};

export const canUserEditPlanning = async (params) => {
	const hasPermission = await CalendarService.canUserEditPlanning(params);
	return hasPermission === true;
};
